import React from 'react';
import { Button } from '@pearsontechnology/aero-components';
import ErrorPage from 'components/ErrorPage';
import messages from './messages';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { HomePageLink } from './styles';

const UnAvailableContent = () => (
  <>
    <ErrorPage
      icon="warningOctagon"
      title={intl.formatMessage(messages.contentNotFoundTitle)}
      message={intl.formatMessage(messages.contentNotFoundDescription)}
    >
      <HomePageLink to="/">
        <Button primary>Back to home</Button>
      </HomePageLink>
    </ErrorPage>
  </>
);

export default UnAvailableContent;
